import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '../Card';
import NoNotifications from './NoNotifications';
import YesNotifications from './YesNotifications';
import ApplicationReject from './ApplicationReject';

const useStyles = makeStyles((theme: any) => ({
  numNotificationsContainer: {
    background: theme.palette.notification.main,
    borderRadius: '100%',
    width: theme.spacing(4),
    height: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  notifications: {
    fontSize: '1.3em',
    marginLeft: theme.spacing(-3),
  },

  numNotifications: {
    margin: 0,
    color: theme.palette.notification.text,
  },
}));

export default function Notifications(props) {
  const classes = useStyles();
  const { notifications, rejectNotifications, setRejectNotifications } = props;

  const showNoNotification =
    notifications?.length === 0 && rejectNotifications?.length === 0;

  return (
    <Card
      title="Notifications"
      topRight={
        <div className={classes.numNotificationsContainer}>
          <h2 className={classes.numNotifications}>
            {notifications?.length + rejectNotifications?.length}
          </h2>
        </div>
      }
    >
      {showNoNotification && <NoNotifications />}
      <ul className={classes.notifications}>
        <>
          {notifications?.length > 0 && (
            <YesNotifications notifications={notifications} />
          )}
          {rejectNotifications?.length > 0 && (
            <ApplicationReject
              rejectNotifications={rejectNotifications}
              setRejectNotifications={setRejectNotifications}
            />
          )}
        </>
      </ul>
    </Card>
  );
}
